import * as React from 'react'
import { SVGProps } from 'react'

export const Brakets = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width ?? 16} height={props.height ?? 12} viewBox="0 0 16 12" {...props}>
    <path
      d="M4.275 2.757c-.15-.164-.4-.164-.575-.024L.1 5.713a.433.433 0 0 0-.1.281c0 .118.025.211.125.282l3.6 3.003A.39.39 0 0 0 4 9.372c.1 0 .2-.023.275-.117.15-.14.15-.399-.025-.516L1 5.994l3.25-2.721c.175-.117.175-.375.025-.516ZM15.85 5.713l-3.6-2.98c-.15-.14-.425-.14-.55.024-.15.14-.15.399.025.516l3.25 2.721-3.25 2.722c-.175.14-.175.375-.025.54.075.093.175.116.3.116a.371.371 0 0 0 .25-.093l3.6-2.98c.1-.094.15-.187.15-.305 0-.094-.05-.187-.15-.281ZM10.125.012C9.9-.035 9.675.059 9.6.247l-4 11.26c-.05.188.05.4.25.47a.44.44 0 0 0 .525-.211l4-11.261c.05-.212-.05-.423-.25-.493Z"
      fill={'currentColor'}
    />
  </svg>
)
